<template>
  <Modal v-bind="$attrs" @close="handleClose" :title="$t('contactSupport.title')">
    <div class="tips-content">
      <div><LogoSvg /></div>
      <div class="essay">
        <slot></slot>
      </div>
      <Button @click="handleClose" size="small">{{ $t("contactSupport.button") }}</Button>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Modal/index.desktop";
import Button from "../Button/button.desktop";
import LogoSvg from "../LogoSvg";
export default {
  name: "ModalTips",
  components: { Modal, Button, LogoSvg },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
/* prettier-ignore */
.tips-content {
  text-align: center;
  padding: 127PX 0 44PX 0;
  .tips-logo {
    display: flex;
    justify-content: center;
    .c-logo {
      height: 60px;
    }
  }
  .essay {
    margin: 22PX 0 90PX 0;
    padding: 0 15px;
      font-weight: 600;
      font-size: 18PX;
      line-height: 25PX;
      color: #ffffff;
    
  }
  @media screen and(max-width: 420px){
    padding: pxToVWForMobile(76) 0 pxToVWForMobile(43) 0;
    .essay {
      margin: pxToVWForMobile(22) auto pxToVWForMobile(61) auto;
      >p{
        font-size: pxToVWForMobile(18);
        line-height: pxToVWForMobile(25);
        &:nth-of-type(1){
          margin-bottom: 15px;
        }
      }
      width: pxToVWForMobile(274);
   
    }
  }
}
</style>
